
<button  class= "btn-md btn-outline-primary border-0 badge mx-2"  (click)="
changeField(h,'sem', 'I',i)" > map to first Sem </button>

<button  class= "btn-md btn-outline-secondary border-0 badge mx-2"  (click)="
changeField(h,'sem', 'II',i)" > map to second Sem </button>
